import React from 'react'
import PageTitle from '../components/PageTitle'
import Link from '../components/Link'
import Layout from '../components/Layout'

const Factbook = () => (
  <Layout>
    <PageTitle name="Interactive Factbook" site="OIRA" />
    {/*<p>
    OIRA is developing a new interactive Factbook using dynamic data visualizations. The first two sections of the new Factbook are available. We are interested in any feedback regarding these visualizations, positive and negative. We want this new application to be useful and informative. 
    </p>*/}
    <p>
    Please send any comments regarding the Factbook to <a href="mailto:oiracontact@ua.edu">oiracontact@ua.edu</a>. Please include the words “Factbook Feedback” in the subject line. The legacy Factbook is available as a <a href="https://oira.ua.edu/factbooklegacy/" target="_blank">static web version</a> or a <a href="https://oira.ua.edu/factbooklegacy/resources/2024-25Factbook.pdf" target="_blank">full PDF version</a>.
    </p>
    <p class="sectionRED half">
      <a href="https://bit.ly/Admissions-and-New-Students" target="_blank">Admissions and New Students</a>
    </p>

    <p class="sectionRED half">
      <a href="https://bit.ly/UA-OIRA-FB-Degrees-Awarded" target="_blank">Degrees Awarded</a>
    </p>

    <p class="sectionRED half">
      <a href="https://tinyurl.com/FB-Faculty-Staff" target="_blank">Faculty and Staff</a>
    </p>

    <p class="sectionRED half">
      <a href="https://tinyurl.com/FB-Other" target="_blank">Other Information</a>
    </p>

    <p class="sectionRED half">
      <a href="https://bit.ly/UA-OIRA-FB-Enrollment" target="_blank">Student Enrollment</a>
    </p>

    <p class="sectionRED half">
      <a href="https://tinyurl.com/FB-Glossary" target="_blank">Glossary</a>
    </p>

  </Layout>
)

export default Factbook
